import { useTranslation } from 'react-i18next'
import { KeysHint } from '@/src/renderer/components/common/KeysHint'

/**
 * Die Tasten der Auswahl-Karten im Setup (#147): Die Karten gehen per Tastatur, aber das sah
 * niemand — die Testerin wechselte zwischen Maus (auswählen) und Enter (weiter). Die Leiste
 * selbst ist `KeysHint` (die Checkliste nutzt sie auch, #181).
 *
 * @example
 * <CardKeysHint />
 */
export function CardKeysHint() {
  const { t } = useTranslation()
  return (
    <KeysHint
      items={[
        { keys: ['←', '→'], label: t('setupCards.keys.select') },
        { keys: [t('setupCards.keys.space')], label: t('setupCards.keys.toggle') },
        { keys: ['↵'], label: t('setupCards.keys.continue') },
      ]}
    />
  )
}
